module.exports = __webpack_public_path__ + "img/map-marker-alt.7a26e55b.png";